import {useMemo} from 'react';
import useTypedSelector from '../../../../../../common/useTypedSelector';
import {NormalTextViewerCoreOption} from '../type/NormalTextViewerCoreOption.interface';
import {getTextViewerThemeColorSet} from '../util/getTextViewerThemeColorSet';

export function useNormalTextViewerCoreOption(): NormalTextViewerCoreOption {
  const theme = useTypedSelector(state => state.textViewer.settings.theme);
  const themeColorSet = useMemo(
    () => getTextViewerThemeColorSet(theme),
    [theme]
  );

  return {
    backgroundColor: themeColorSet.bg,
    textColor: themeColorSet.text,
    isDark: themeColorSet.isDark,
  };
}
